import { render, staticRenderFns } from "./FederationMissingNotice.vue?vue&type=template&id=787bea54&shadow"
import script from "./FederationMissingNotice.vue?vue&type=script&lang=js&shadow"
export * from "./FederationMissingNotice.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./FederationMissingNotice.vue?vue&type=style&index=0&id=787bea54&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports